<template>
  <div class="module-title">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'ModuleTitle',
  props: {
    title: {
      type: String,
      default: '模块标题'
    }
  }
}
</script>

<style scoped>
.module-title {
  height: 50px;
  line-height: 50px;
  width: 100%;
  text-align: left;
  background: url(../assets/imgs/sy-title-bg.jpg) no-repeat;
  background-position: left bottom;
  text-indent: 0.8em;
  font-size: 22px;
  font-weight: bold;
}
</style>
